<transflo-scheduler-no-auth *ngIf="isUnauthorized"></transflo-scheduler-no-auth>
<div *ngIf="!isUnauthorized">
  <transflo-layout-control-calendar style="position:sticky"></transflo-layout-control-calendar>
  <transflo-scheduler-agenda></transflo-scheduler-agenda>
  <transflo-scheduler-footer class="fixed-bottom">
  </transflo-scheduler-footer>
</div>
